import { DrawerModal } from '@fagmobler/ui';
import { ServerProduct } from '@/lib/janitsjar/Product';
import { MaterializedProductEnrichment } from '@/lib/sanity/queries';
import Divider from '@/cataloguePages/productPageWithVariants/components/Divider';
import {
  ArrowTopRightOnSquareIcon,
  ChevronDownIcon,
  ChevronUpIcon,
} from '@heroicons/react/20/solid';
import { Fragment, useState } from 'react';
import Link from 'next/link';
import { FagmoblerPortableTextDrawer } from '@/components/portableText/drawer';

type ProductDetailsProps = {
  product: ServerProduct;
  productEnrichment: MaterializedProductEnrichment | null;
  openedModal: string | null;
  closeModal: () => void;
};

export const ProductDetailsModalKey = 'product_details';

export default function ProductDetails({
  product,
  productEnrichment,
  openedModal,
  closeModal,
}: ProductDetailsProps) {
  const [isPDFOpen, setIsPDFOpen] = useState(false);
  const [isPropertiesOpen, setIsPropertiesOpen] = useState(!productEnrichment);
  const [isEditorialOpen, setIsEditorialOpen] = useState(true);

  return (
    <DrawerModal
      isOpen={openedModal === ProductDetailsModalKey}
      onClose={closeModal}
      title="Produktdetalj"
    >
      <div className="p-4 pt-2 md:pt-2 md:p-6 flex flex-col gap-2 items-start">
        {!!product.properties?.length && (
          <>
            <button
              onClick={() => setIsPropertiesOpen((prev) => !prev)}
              className="w-full flex items-center justify-between cap-link-sm font-bold my-2 no-underline hover:underline"
            >
              Produktegenskaper{' '}
              {isPropertiesOpen ? (
                <ChevronUpIcon className="size-4" />
              ) : (
                <ChevronDownIcon className="size-4" />
              )}
            </button>
            {isPropertiesOpen && (
              <div className="grid grid-cols-[auto_1fr] gap-2 items-center mb-10 md:mb-5">
                {product.properties.map((prop, index) => (
                  <Fragment key={index}>
                    <span className="cap-sm font-bold">{prop.label}:</span>
                    <p className="body-sm">
                      {prop.value} {prop.unit}
                    </p>
                  </Fragment>
                ))}
              </div>
            )}
            <Divider />
          </>
        )}
        {!!product.pdfs?.length && (
          <>
            <button
              onClick={() => setIsPDFOpen((prev) => !prev)}
              className="w-full flex items-center justify-between cap-link-sm font-bold my-2 no-underline hover:underline"
            >
              Les vår katalog{' '}
              {isPDFOpen ? (
                <ChevronUpIcon className="size-4" />
              ) : (
                <ChevronDownIcon className="size-4" />
              )}
            </button>
            {isPDFOpen && (
              <div className="flex flex-col gap-4 mt-4">
                {product.pdfs.map((pdf) => {
                  return (
                    <div key={pdf._id} className="flex gap-2 h-24">
                      <iframe
                        src={`${pdf.ipaperIframeUrl}-/embedded/flat/singlepage/1/`}
                        className="aspect-[61/79] h-full"
                      />
                      <div className="flex flex-col justify-between h-20 py-2">
                        <span className="body-sm">{pdf.title}</span>

                        {pdf.ipaperIframeUrl && (
                          <Link
                            className="cap-link-sm flex gap-1 items-center font-bold"
                            href={pdf.ipaperIframeUrl}
                            target={'_blank'}
                          >
                            Åpne katalog i ny fane{' '}
                            <ArrowTopRightOnSquareIcon className="size-3" />
                          </Link>
                        )}
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
            <Divider />
          </>
        )}
        {productEnrichment && (
          <>
            <button
              onClick={() => setIsEditorialOpen((prev) => !prev)}
              className="w-full flex items-center justify-between cap-link-sm font-bold my-2 no-underline hover:underline"
            >
              {product.posterName}{' '}
              {isPropertiesOpen ? (
                <ChevronUpIcon className="size-4" />
              ) : (
                <ChevronDownIcon className="size-4" />
              )}
            </button>

            {isEditorialOpen && (
              <div className="[&>*:first-child]:hidden [&>*]:mt-0 [&>*]:mb-4 ">
                <FagmoblerPortableTextDrawer
                  value={productEnrichment.body}
                  forbidNegativeMargins
                />
              </div>
            )}
            <Divider />
          </>
        )}
      </div>
    </DrawerModal>
  );
}
